(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const input = root.querySelector('[name="quantity"]');
    const labels = JSON.parse(root.querySelector('[data-dtr-labels]').textContent);
    const money = new Intl.NumberFormat(root.dataset.locale || 'de', {style:'currency', currency:root.dataset.currency || 'EUR'});
    const price = Number(root.dataset.price);
    const presets = root.querySelectorAll('[data-dtr-quantity]');
    const update = () => {
      const quantity = Math.max(Number(input.min) || 1, Number(input.value) || 1);
      const rate = quantity >= 4 ? 15 : quantity >= 2 ? 10 : 0;
      const base = price * quantity;
      const saving = Math.floor(price * rate / 100) * quantity;
      const total = money.format((base - saving) / 100);
      root.querySelector('[data-dtr-total]').textContent = total;
      const original = root.querySelector('[data-dtr-original]');
      original.hidden = rate === 0;
      original.textContent = money.format(base / 100);
      const saved = root.querySelector('[data-dtr-savings]');
      saved.hidden = rate === 0;
      saved.textContent = labels.saved.replace('__AMOUNT__',money.format(saving / 100)).replace('__PERCENT__',rate);
      const unit = root.querySelector('[data-dtr-unit]');
      unit.hidden = rate === 0;
      unit.textContent = labels.unit.replace('__PRICE__',money.format((price - Math.floor(price * rate / 100)) / 100));
      root.querySelector('[data-dtr-gift]').textContent = quantity >= 6 ? labels.gift_active : labels.gift;
      root.querySelector('.dtr-gift').classList.toggle('is-active',quantity >= 6);

      presets.forEach(button => button.setAttribute('aria-pressed',Number(button.dataset.dtrQuantity) === quantity ? 'true' : 'false'));
    };
    presets.forEach(button => button.addEventListener('click',() => {input.value=button.dataset.dtrQuantity;input.dispatchEvent(new Event('change',{bubbles:true}));}));
    input.addEventListener('input',update);
    input.addEventListener('change',update);
    update();
  };
  document.querySelectorAll('[data-dtr-product]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-dtr-product]').forEach(init));
})();
